import { GET_COURSES } from "constants/courses";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_COURSES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
